var Z = Object.defineProperty, z = Object.defineProperties;
var F = Object.getOwnPropertyDescriptors;
var m = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, T = Object.prototype.propertyIsEnumerable;
var v = (a, e, n) => e in a ? Z(a, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : a[e] = n, y = (a, e) => {
  for (var n in e || (e = {}))
    N.call(e, n) && v(a, n, e[n]);
  if (m)
    for (var n of m(e))
      T.call(e, n) && v(a, n, e[n]);
  return a;
}, f = (a, e) => z(a, F(e));
import { defineComponent as V, toRefs as W, ref as A, computed as o, unref as t, openBlock as s, createBlock as w, resolveDynamicComponent as L, mergeProps as j, withCtx as q, createElementBlock as i, createElementVNode as G, normalizeStyle as d, createCommentVNode as k } from "vue";
import { BImage as H } from "@bilibili-intl/components";
const J = {
  key: 1,
  class: "bstar-avatar__error"
}, K = ["src"], tt = /* @__PURE__ */ V({
  __name: "avatar-pendant",
  props: {
    avatar: null,
    nickname: null,
    pendant: { default: "" },
    showRedDot: { type: Boolean, default: !1 },
    link: { default: "" },
    width: null,
    newWindow: { type: Boolean, default: !0 },
    isMobile: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(a, { emit: e }) {
    const n = a, h = 8, g = 4, x = 6, { avatar: b, pendant: u, link: c, width: r, newWindow: B, isMobile: E } = W(n), _ = A(!1), S = o(() => t(c) ? "a" : "div"), p = o(() => t(E) ? x : g), $ = o(() => ({
      width: `${t(r)}px`,
      height: `${t(r)}px`
    })), C = o(() => ({
      width: `${t(r) / 2}px`,
      height: `${t(r) / 2}px`
    })), D = o(() => ({
      width: `${t(r) + h}px`,
      height: `${t(r) + h}px`
    })), I = o(() => ({
      width: `${t(p)}px`,
      height: `${t(p)}px`
    })), P = o(() => {
      const l = {
        class: "bstar-avatar",
        style: t($)
      };
      return t(c) ? f(y({}, l), { href: t(c), target: t(B) ? "_blank" : "_self" }) : l;
    }), M = o(() => t(u)), O = () => {
      _.value = !0;
    }, R = (l) => {
      e("click", l);
    };
    return (l, Q) => (s(), w(L(t(S)), j(t(P), { onClick: R }), {
      default: q(() => [
        _.value ? (s(), i("div", J, [
          G("i", {
            class: "bstar-avatar__icon",
            style: d(t(C))
          }, null, 4)
        ])) : (s(), w(t(H), {
          key: 0,
          class: "bstar-avatar__image",
          src: t(b),
          width: t(r) * 2,
          height: t(r) * 2,
          alt: a.nickname,
          loading: "lazy",
          onError: O
        }, null, 8, ["src", "width", "height", "alt"])),
        t(M) ? (s(), i("img", {
          key: 2,
          class: "bstar-avatar__pendant",
          style: d(t(D)),
          src: t(u)
        }, null, 12, K)) : k("", !0),
        a.showRedDot ? (s(), i("div", {
          key: 3,
          class: "bstar-avatar__dot",
          style: d(t(I))
        }, null, 4)) : k("", !0)
      ]),
      _: 1
    }, 16));
  }
});
export {
  tt as BAvatar
};
//# sourceMappingURL=b-avatar.es.js.map
